// extracted by mini-css-extract-plugin
module.exports = {"h1lg5vt5":"h1lg5vt5","h9ecqqg":"h9ecqqg","fnl64gh":"fnl64gh","my0qslp":"my0qslp","wqj4iv9":"wqj4iv9","sgnq5rg":"sgnq5rg","b15ytzok":"b15ytzok","s1p26rre":"s1p26rre"};